<template>
	<div>
		<component :is="status" @changeSetor="reorderCards" @statusSelected="setStatusSelected"
			@changeSubSetor="reorderSubSetor" :call="card_status_count.ligacao" :pause="card_status_count.pausa"
			:active="card_status_count.ativo" :logoff="card_status_count.deslogado" :todos="card_status_count.todos">
		</component>

		<div class="preferencias mb-4 d-flex">
			<input id="searchramal" maxlength="4" class="form-control form-control-sm" type="text"
				placeholder="Procure seu ramal" style="width: 20%;margin-left: 40%;border-radius: 5px !important;">
		</div>
		{{ arrHide['9090'] }}
		<div class="row" id="arrOperadores">

			<component v-for="(card, index) in cards" :key="index" :is="card.ramal_component" :nome="card.nome"
				:extension="card.extension" :connection="card.connection" :filas="card.filas"
				:alias_filas="card.alias_filas" @changeStatus="setStatus"
				:class="{ 'hide': arrHide.includes(card.extension) }"></component>

		</div>

	</div>
</template>

<script>

import card from './CardRealtime.vue'
import status from './CardStatus.vue'


export default {
	data() {
		return {
			card_status_count: {
				ligacao: 0, // ligacao
				pausa: 0, //pausa == pause
				ativo: 0, // ativo == active
				deslogado: 0, //
				todos: 0
			},
			cards: [],
			arrHide: [],
			status: 'status', // referente ao componente status
			order: '*',
			statusSelected: '*',
			sub_alias: '*'
		}
	},
	components: { card, status },
	mounted() {

		axios.get('/realtime/list').then(response => {

			response.data.forEach(el => {
				let obj = {
					ramal_component: 'card',
					nome: el.name,
					extension: el.extension_line,
					connection: realtime,
					filas: el.fila,
					alias_filas: el.sector_name,
					subsetores_concat: el.alias_concat_name,
					status: 'deslogado'
				}
				this.cards.push(obj);
			});
			this.card_status_count.todos = this.cards.length;
			this.card_status_count.deslogado = this.card_status_count.todos

			realtime.emit('QueueStatus', {});
		});


	},

	methods: {
		getCards() {
			if (this.sub_alias == '*') {
				this.allSubSectors();
			} else {
				this.superSpecific();
			}


		},
		allSubSectors() {
			this.arrHide = [];
			// TODAS AS FILAS, TODOS OS STATUS
			if (this.order == '*' && this.statusSelected == '*') {
				this.arrHide = [];
				return;
			}


			// TODAS AS FILAS, STATUS SELECIONADO
			if (this.order == '*') {
				this.cards.map(el => {
					if (!el.status.includes(this.statusSelected)) {
						this.arrHide.push(el.extension);
					}
				});
				return;
			}

			// FILA SELECIONADO, TODOS OS STATUS
			if (this.statusSelected == '*') {
				this.cards.map(el => {
					if (!el.alias_filas.includes(this.order)) {
						this.arrHide.push(el.extension);
					}
				});
				return;
			}

			// FILA E STATUS SELECIONADO
			return this.cards.filter(el => {
				if (!(el.alias_filas.includes(this.order) && el.status.includes(this.statusSelected))) {
					this.arrHide.push(el.extension);
				}
			});
		},
		superSpecific() {
			this.arrHide = [];


			if (this.statusSelected == '*') {
				this.cards.map(el => {
					if (!el.subsetores_concat.includes(`${this.order}-${this.sub_alias}`)) {
						this.arrHide.push(el.extension);
					}
				});
				return;
			}

			this.cards.map(el => {
				if (!(
					el.subsetores_concat.includes(`${this.order}-${this.sub_alias}`)
					&&
					el.status.includes(this.statusSelected)
				)) {
					this.arrHide.push(el.extension);
				}
			});
		},
		reorderCards(e) {
			this.order = e;
			this.getCards();
		},
		reorderSubSetor(e) {
			this.sub_alias = e;
			this.getCards();
		},
		setStatus(e) {

			this.cards.map((el) => {
				if (el.extension == e.operador) {

					this.card_status_count[el.status]--;
					this.card_status_count[e.status]++;

					el.status = e.status
				}
			});

			this.getCards()

		},

		setStatusSelected(e) {
			this.statusSelected = e;
			this.getCards()
		}
	}
}
</script>
